import { ReactNode } from "react";
import styles from "@/pages/index.module.css";
import { Link } from "react-router";
import { articles } from "@/utils/news";
import { NewsArticle } from "@/components/NewsArticle";

export function NewsModal(): ReactNode {
  const olderArticles = articles.slice(1);

  return (
    <div className={styles.newsModalContainer}>
      <Link to="/" className={styles.modalClose}>
        𝗫
      </Link>
      <h1 className={styles.newsHeader}>News</h1>
      <div className={`${styles.newsArticles}`}>
        {olderArticles.map((article, index) => (
          <div key={index}>
            <NewsArticle article={article} />
            {index < olderArticles.length - 1 && <hr />}
          </div>
        ))}
      </div>
    </div>
  );
}
